import React, { useState } from "react";
import ShoppingItem from "./ShoppingItem";

/**
 * Groupe d'articles par catégorie — en-tête repliable + liste d'items.
 */
function CategoryGroup({ category, items, onCheck, onDelete, onEdit, showOwner, canCheck, canDelete, categories }) {
  const [collapsed, setCollapsed] = useState(false);
  const uncheckedCount = items.filter((i) => !i.checked).length;

  return (
    <div className="category-group">
      <button
        className="category-header"
        onClick={() => setCollapsed(!collapsed)}
        aria-expanded={!collapsed}
        aria-label={`${category} — ${uncheckedCount} article${uncheckedCount > 1 ? "s" : ""}`}
      >
        <span className="category-name">
          <span className={`category-arrow ${collapsed ? "collapsed" : ""}`}>{"\u25BC"}</span> {category}
        </span>
        <span className="category-count">{uncheckedCount} article{uncheckedCount > 1 ? "s" : ""}</span>
      </button>

      <div className={`category-items-wrapper ${collapsed ? "collapsed" : ""}`}>
        <ul className="category-items">
          {items.map((item) => (
            <ShoppingItem
              key={item.ids ? item.ids.join("-") : item.id}
              item={item}
              onCheck={onCheck}
              onDelete={onDelete}
              onEdit={onEdit}
              showOwner={showOwner}
              canCheck={canCheck}
              canDelete={canDelete}
              categories={categories}
            />
          ))}
        </ul>
      </div>
    </div>
  );
}

export default CategoryGroup;
